import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-8 px-4 sm:px-6 lg:px-8 bg-[#0a0a0a] relative" data-id="element-75">
      <div className="max-w-3xl mx-auto text-center space-y-4" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-77">
          <h2 className="text-2xl md:text-3xl font-serif text-white mb-3 leading-[1.05]" data-id="element-78">
            Hay un momento que nadie confiesa.
          </h2>

          <div className="space-y-2 text-base md:text-lg text-zinc-300 font-light leading-[1.2]" data-id="element-79">
            <p data-id="element-80">
              Estás al lado de tu pareja… <br data-id="element-81" />y aun así te sientes{' '}
              <span className="text-white font-normal" data-id="element-82">solo/a</span>.
            </p>
            <p data-id="element-83">
              No porque falte techo. <br data-id="element-84" />
              Porque falta{' '}
              <span className="text-[#d4a574] italic" data-id="element-85">puerta abierta</span>.
            </p>
            <p data-id="element-86">
              Y cada vez que intentas "hablarlo", pasa lo mismo: <br data-id="element-87" />
              se pone a la defensiva, se cansa, se cierra… o te responde con un
              "ok" que se siente como pared.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4,
        duration: 0.8
      }} className="p-4 border-l-2 border-[#d4a574] bg-zinc-900/30 text-left" data-id="element-88">
          <p className="text-base text-zinc-200 italic leading-[1.3]" data-id="element-89">
            "Esta Guía no te enseña a discutir mejor. Te enseña a volver a
            acercarte sin humillarte. En 24 horas."
          </p>
        </motion.div>
      </div>
    </section>;
}